"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M13.821 8.96088L10.429 12.8189C10.193 13.0389 9.808 13.0389 9.571 12.8189L6.179 8.96088C5.797 8.60688 6.068 7.99988 6.609 7.99988H13.392C13.933 7.99988 14.204 8.60688 13.821 8.96088ZM10 1.99988C5.582 1.99988 2 5.58188 2 9.99988C2 14.4179 5.582 17.9999 10 17.9999C14.419 17.9999 18 14.4179 18 9.99988C18 5.58188 14.419 1.99988 10 1.99988Z",
    fill: "#727B7F"
  }));
};